var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { BlocksElement } from '../BlocksElement';
import styles from './layout-container.styles';
/**
 * @slot default - The contents of the layout container
 * @csspart base - The component's base wrapper.
 * @csspart part-default - The component's default slot.
 */
export class BlocksLayoutContainer extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         * isFluid
         * It let container grow 100% to the width of the container
         */
        this.isFluid = false;
    }
    static { this.styles = styles; }
    /**
     * Connected callback lifecycle
     */
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        const componentClassName = this.componentClassNames('cat-l-layout-container', {
            'cat-l-layout-container--overflow-right-sm': this.behavior === 'overflow-right-sm',
            'cat-l-layout-container--fluid': this.isFluid
        });
        return html `
      <div part="base" class="${componentClassName}">
        <slot part="part-default"></slot>
      </div>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksLayoutContainer.prototype, "behavior", void 0);
__decorate([
    property({ type: Boolean })
], BlocksLayoutContainer.prototype, "isFluid", void 0);
if (customElements.get('cat-layout-container') === undefined) {
    customElements.define('cat-layout-container', BlocksLayoutContainer);
}
